import { render, staticRenderFns } from "./HelpAssistantWidget.vue?vue&type=template&id=ba26c47c&scoped=true"
import script from "./HelpAssistantWidget.vue?vue&type=script&lang=js"
export * from "./HelpAssistantWidget.vue?vue&type=script&lang=js"
import style0 from "./HelpAssistantWidget.vue?vue&type=style&index=0&id=ba26c47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba26c47c",
  null
  
)

export default component.exports